<template>
    <div class="behaviorScoreDetail">
        <div v-if="dataList.length" :immediate-check="false">
            <dl class="behaviorScoreDetail-box">
                <!-- v-for="(item,index) in dataList" -->
                <div class="behaviorScoreDetail-item" v-for="(item,index) in dataList" :key="index">
                    <div class="title-box">
                        <span class="month" v-if="item.changeRecordList.length">{{item.changeRecordList[0].changeTime.slice(6,7)}}月</span><span class="score">{{item.totalScore}}分</span>
                    </div>
                    <div class="content-box-item" v-for="(ele,eleIndex) in item.changeRecordList" :key="eleIndex">
                        <div class="left">
                            <p class="left-title">{{ele.changeTypeName}}</p>
                            <p class="left-time">{{ele.changeTimeStr}}</p>
                        </div>
                        <p class="right" v-if="ele.changeScore>0" style="color: #FE4F51">+{{ele.changeScore}}</p>
                        <p class="right" v-else>{{ele.changeScore}}</p>
                    </div>
                </div>
            </dl>
            <p class="more-class" v-if="currentPage < 3" @click="getBehaviorScoreChangeRecord(1)">点击查看更多记录</p>
            <p class="end-class" v-else>仅展示最近四个月的分值</p>
        </div>
        <div class="empty-class" v-if="finished && !dataList.length">
            <img src="../../assets/img/behavior_empty.png">
            <p>暂无明细</p>
        </div>
    </div>
</template>
<script>
import mobileType from "@/utils/mobileType";
import utils from "@/utils/util";
import { getBehaviorScoreChangeRecord } from "@/apis/behaviorScore/index";
export default {
    name: "behaviorScoreDetail",
    data() {
        return {
            dataList: [],
            finished: false,
            currentPage: 0,
            loading: false,
            params: {
                scale: "2.0",
                areaCode: "110105",
                sysVersion: "14.7",
                token:
                    "MTAxNzAwMTM4OjcwMDoyMDIzMDQyNDExMDEwMjI2ODo3MDIxNzQ3Qy0xNjJGLTQ2RDktODc2MS05OUFBMzYyMTAxM0E=",
                appChannel: "AppStore",
                platform: "2",
                softVersion: "1.2.51",
                display: "1334*750",
                role: "2",
                uuidString: "7021747C-162F-46D9-8761-99AA3621013A",
                channel: "1020000000",
                cityCode: "110100",
                idfv: "912FD003-76D6-4DAC-B98C-4B6FFF5A00C6"
            },
            timer: null,
            finishedText: "暂无数据",
            searchOptions: {}
        };
    },
    created() {
        window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
        this.getUserInfoFromApp();
    },
    computed: {},
    methods: {
        getUserInfoFromApp() {
            let params = {
                methodName: "getDataFromNative", //定义与原生的方法名(固定)
                type: 1 //业务类型(固定)
            };
            if (mobileType.isIOS()) {
                window.webkit.messageHandlers.getDataFromVue.postMessage(
                    params
                );
            } else if (mobileType.isAndroid()) {
                window.Android.getDataFromVue(JSON.stringify(params));
            }
        },
        getDataFromNative(params) {
            if (mobileType.isIOS()) {
                this.params = params;
            } else if (mobileType.isAndroid()) {
                this.params = JSON.parse(params);
            }
            this.getBehaviorScoreChangeRecord()
        },
        // 积分流水列表
        async getBehaviorScoreChangeRecord(num) {
            let params = { ...this.params };
            if (num) {
                this.currentPage++;
            }
            params.data = JSON.stringify({
                startTime: `${this.getUpMonth()}-01 00:00:00`,
                endTime: `${this.getUpMonth()}-31 24:00:00`,
                currentPage: this.currentPage
            });
            try {
                const res = await getBehaviorScoreChangeRecord(params);
                if (res.code == 1) {
                    let resData = JSON.parse(res.data);
                    if (resData.changeRecordList.length > 0) {
                        this.dataList.push(resData);
                    } else if (
                        resData.changeRecordList.length == 0 &&
                        this.currentPage < 3
                    ) {
                        this.currentPage++;
                        this.getBehaviorScoreChangeRecord();
                    }
                    this.refreshing = false;
                    if (this.currentPage == 3) {
                        this.finished = true;
                    }
                } else {
                    this.finished = true;
                    this.$toast(res.msg);
                }
            } catch (error) {
                console.log(error);
            }
        },
        // 月份
        getUpMonth() {
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            var year2 = year;
            // 注意：1月份返回的是0
            var month2 = parseInt(month) - this.currentPage;
            if (month2 <= 0) {
                year2 = parseInt(year2);
                month2 = 12;
            }
            if (month2 < 10) {
                month2 = "0" + month2;
            }
            var m = year2.toString();
            var n = month2.toString();
            var t2 = `${m}-${n}`;
            // 最终返回格式2022-12
            console.log(t2);
            return t2;
        },
        onLoad() {
            this.loading = false;
            // 设置定时器做节流处理，避免滚动时频繁触发加载事件
            if (!this.timer) {
                this.timer = setTimeout(() => {
                    this.getBehaviorScoreChangeRecord();
                    // 清除定时器，释放内存
                    this.timer = null;
                }, 500);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.behaviorScoreDetail {
    min-height: 100vh;
    width: 375px;
    background: #f2f2f2;
    .behaviorScoreDetail-box {
        .behaviorScoreDetail-item {
            color: #333;
            .title-box {
                padding: 14px 16px;
                display: flex;
                justify-content: space-between;
                font-family: PingFangSC-Regular, PingFang SC;
                .month {
                    font-size: 16px;
                    font-weight: 400;
                }
                .score {
                    color: #999;
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                }
            }
            .content-box-item {
                background: #fff;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #ededed;
                padding: 12px 16px;
                color: #333;
                .left-title {
                    height: 20px;
                    line-height: 20px;
                }
                .left-time {
                    margin-top: 6px;
                    font-weight: 400;
                    color: #999999;
                    font-size: 12px;
                }
                .right {
                    font-weight: 600;
                    font-size: 16px;
                }
                &:last-child {
                    border-bottom: none;
                }
            }
        }
    }
    .more-class {
        text-align: center;
        height: 18px;
        font-size: 14px;
        color: #333333;
        line-height: 18px;
        margin-top: 16px;
    }
    .end-class {
        text-align: center;
        height: 18px;
        font-size: 14px;
        color: #9999;
        line-height: 18px;
        margin-top: 16px;
    }
    .empty-class {
        text-align: center;
        margin: 0 auto;
        img {
            width: 180px;
            height: 180px;
            margin-top: 88px;
        }
        p {
            height: 18px;
            font-size: 14px;
            color: #999999;
            line-height: 18px;
            margin-top: 10px;
        }
    }
}
</style>
